import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import platform from "Pub/js/platform";
import { Dropdown } from 'antd'
import { judgeAddCardMenuShow } from '../../methods/judgeMenuShow';
import BatchSelection from './BatchSelection'
import MultiSelection from './MultiSelection'
import { langCheck } from 'Pub/js/utils';
import { setMetaTreeNodes } from "Store/ZoneSetting/action";

const { NCDropdown } = platform.base;

class MoveCardSelection extends Component {
	constructor(props) {
		super(props);
	}

	renderMenu = () => {
		let { metaTreeNodes, cardInfo, showCardCheckboxController, visible, json } = this.props;
		if (visible === false) {
			return <Fragment />;
		}
		return (
			<div
				className={`${this.props.className} move-card-menu nc-theme-area-bgc nc-theme-common-font-c`}
				onMouseEnter={this.showCardContentIcon}
				onMouseLeave={this.handleMouseLeave}
			>
				{
					judgeAddCardMenuShow(metaTreeNodes, cardInfo.areaid)
						? <ul>
							<li onClick={this.addMetaItemFront}>
								{/*新增于前*/}
								{langCheck('ZoneSetting-000266', 'pages', json)}
							</li>
							<li onClick={this.addMetaItemBehind}>
								{/*新增于后*/}
								{langCheck('ZoneSetting-000267', 'pages', json)}
							</li>

						</ul>
						: <ul>
							{
								showCardCheckboxController[cardInfo.areaid] !== true
									? <BatchSelection
										showCheckbox={this.showCheckbox}
										checkAllCard={this.checkAllCard}
										json={json}
									/>
									: <MultiSelection
										checkAllCard={this.multiSelectCheckAll}
										clearCheckedCard={this.clearCheckedCard}
										revertThisAction={this.revertThisAction}
										moveCardFront={this.moveCardFront}
										moveCardBehind={this.moveCardBehind}
										json={json}
									/>
							}
						</ul>
				}
			</div>
		)
	};

	showCardContentIcon = (e) => {
		this.props.handleIconShow(true)
	};

	handleMouseLeave = (e) => {
		this.props.handleIconShow(false);

		setTimeout((e) => {
			let { cardDom } = this.props;
			if (cardDom) {
				let dom = cardDom.querySelector('.move-card-selection');
				dom.clientWidth === 0
					&& this.props.toggleMenuVisible();
			}
		},100)
	};

	addMetaItemFront = (e) => {
		let { addMetaItem, metaTreeNodes, index, cardInfo, setMetaTreeNodes } = this.props;
		e.stopPropagation();
		let metaTreeAreaId = metaTreeNodes[0] && metaTreeNodes[0].props.dataRef.targetAreaID;

		if (metaTreeAreaId === cardInfo.areaid) {
			addMetaItem({
				selectedTreeNode: metaTreeNodes,
				targetAreaID: cardInfo.areaid,
				dataRef: {},
				dropIndex: index
			});
			setMetaTreeNodes([]);
			this.props.toggleMenuVisible();
			this.props.handleIconShow(false);
		}

	};

	addMetaItemBehind = (e) => {
		let { addMetaItem, metaTreeNodes, index, cardInfo, setMetaTreeNodes } = this.props;
		e.stopPropagation();
		let metaTreeAreaId = metaTreeNodes[0] && metaTreeNodes[0].props.dataRef.targetAreaID;
		if (metaTreeAreaId === cardInfo.areaid) {
			addMetaItem({
				selectedTreeNode: metaTreeNodes,
				targetAreaID: cardInfo.areaid,
				dataRef: {},
				dropIndex: index + 1
			});
			setMetaTreeNodes([]);
			this.props.toggleMenuVisible();
			this.props.handleIconShow(false);
		}
	};

	multiSelectCheckAll = (e) => {
		let { checkAllCard, cardInfo } = this.props;
		e.stopPropagation();
		checkAllCard(cardInfo);
	};

	showCheckbox = (e) => {
		let { cardInfo } = this.props;
		e.stopPropagation();
		this.props.setCardCheckboxState(cardInfo);
		this.props.handleIconShow(false);
		this.props.toggleMenuVisible();
		this.props.handleCheckCard(true)
	};

	checkAllCard = (e) => {
		e.stopPropagation();
		let { cardInfo } = this.props;
		this.props.setCardCheckboxState(cardInfo);
		this.props.checkAllCard(cardInfo);
		this.props.handleIconShow(false);
		this.props.toggleMenuVisible();
	};

	clearCheckedCard = (e) => {
		let { cardInfo } = this.props;

		e.stopPropagation();
		this.props.toggleMenuVisible();
		this.props.clearCheckedCard(cardInfo);
		this.props.handleIconShow(false);
	};

	revertThisAction = (e) => {
		let { cardInfo } = this.props;
		e.stopPropagation();
		this.props.toggleMenuVisible();
		this.props.revertThisAction(cardInfo);
		this.props.handleIconShow(false);
	};

	moveCardFront = (e) => {
		e.stopPropagation();
		let { cardInfo } = this.props;
		this.props.batchMoveCard(cardInfo, 'front');
		this.revertThisAction(e);
	};

	moveCardBehind = (e) => {
		e.stopPropagation();
		let { cardInfo } = this.props;
		this.props.batchMoveCard(cardInfo, 'behind');
		this.revertThisAction(e);
	};

	render() {
		let { visible, toggleMenuVisible } = this.props;
		return (
			<React.Fragment>
				<Dropdown
					placement='topCenter'
					overlay={this.renderMenu()}
					visible={visible}
				>
					<span
						className='move-card-selection'
						onClick={toggleMenuVisible}
					>...</span>
				</Dropdown>

			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		metaTreeNodes: state.zoneSettingData.metaTreeNodes,
		selectedArea: state.zoneSettingData.selectedArea
	};
}

export default connect(
	mapStateToProps,
	{
		setMetaTreeNodes
	}
)(MoveCardSelection);
